import React from 'react';
import { motion } from 'framer-motion';
import { SUPPORT_LINKS } from '../../config/appConfig';

const MethodMaintenanceModal = ({ onClose }) => {
    return (
        <div className="relative w-full max-w-md mx-auto">
            {/* Header */}
            <div className="flex justify-between items-start mb-6">
                <div className="flex items-center space-x-3">
                    <div className="flex items-center justify-center h-10 w-10 rounded-full bg-sky-500/20">
                        <i className="fas fa-tools text-sky-400 text-lg"></i>
                    </div>
                    <h2 className="text-xl font-semibold text-gray-100">Method Maintenance</h2>
                </div>
                <button
                    onClick={onClose}
                    className="text-gray-400 hover:text-white transition-colors p-1 rounded-md hover:bg-dark-600"
                    aria-label="Close modal"
                >
                    <i className="fas fa-times text-lg"></i>
                </button>
            </div>

            {/* Content */}
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20, transition: { duration: 0.15 } }}
                transition={{ duration: 0.25, ease: "circOut" }}
                className="space-y-6"
            >
                {/* Main Message */}
                <div className="bg-gradient-to-br from-dark-600 to-dark-700 rounded-xl p-6 border border-dark-500">
                    <div className="text-center space-y-4">
                        <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-gradient-to-br from-sky-500/20 to-blue-500/20 mb-4">
                            <i className="fas fa-wrench text-sky-400 text-3xl"></i>
                        </div>

                        <h3 className="text-lg font-semibold text-gray-100">
                            Method Temporarily Unavailable
                        </h3>

                        <div className="text-gray-300 space-y-3 leading-relaxed">
                            <p>
                                This method is currently undergoing scheduled maintenance to ensure optimal performance and security.
                            </p>
                            <p>
                                We expect it to be back online <span className="text-accent-green font-medium">within a few days</span>.
                            </p>
                            <p className="text-sm text-gray-400">
                                We apologize for any inconvenience this may cause and appreciate your patience.
                            </p>
                        </div>
                    </div>
                </div>

                {/* Social Links */}
                <div className="bg-dark-600/50 rounded-xl p-4 border border-dark-500">
                    <p className="text-sm text-gray-300 text-center mb-3">
                        Stay updated on maintenance status:
                    </p>
                    <div className="grid grid-cols-2 gap-3">
                        <motion.a
                            whileHover={{ scale: 1.02 }}
                            whileTap={{ scale: 0.98 }}
                            href={SUPPORT_LINKS.discord}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center justify-center space-x-2 bg-[#5865F2]/20 hover:bg-[#5865F2]/30 text-[#5865F2] rounded-lg px-4 py-2.5 transition-all duration-200 border border-[#5865F2]/30"
                        >
                            <i className="fab fa-discord text-lg"></i>
                            <span className="font-medium text-sm">Discord</span>
                        </motion.a>
                        <motion.a
                            whileHover={{ scale: 1.02 }}
                            whileTap={{ scale: 0.98 }}
                            href={SUPPORT_LINKS.telegram}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center justify-center space-x-2 bg-[#0088cc]/20 hover:bg-[#0088cc]/30 text-[#0088cc] rounded-lg px-4 py-2.5 transition-all duration-200 border border-[#0088cc]/30"
                        >
                            <i className="fab fa-telegram text-lg"></i>
                            <span className="font-medium text-sm">Telegram</span>
                        </motion.a>
                    </div>
                </div>

                {/* Action */}
                <div className="pt-2">
                    <motion.button
                        whileHover={{ scale: 1.02 }}
                        whileTap={{ scale: 0.98 }}
                        onClick={onClose}
                        className="w-full inline-flex justify-center items-center rounded-lg bg-gradient-to-r from-accent-purple to-accent-blue text-white font-medium px-6 py-3 hover:from-accent-purple/90 hover:to-accent-blue/90 focus:outline-none focus:ring-2 focus:ring-accent-purple/50 transition-all duration-200 shadow-lg"
                    >
                        <i className="fas fa-check mr-2"></i>
                        Understood
                    </motion.button>
                </div>
            </motion.div>
        </div>
    );
};

export default MethodMaintenanceModal;